import { render } from "./PatientNotesSheet.vue?vue&type=template&id=04d2a0ea"
import script from "./PatientNotesSheet.vue?vue&type=script&lang=ts"
export * from "./PatientNotesSheet.vue?vue&type=script&lang=ts"
script.render = render

export default script